import { render, staticRenderFns } from "./yixiangbiao.vue?vue&type=template&id=5f3cfdf4&scoped=true"
import script from "./yixiangbiao.vue?vue&type=script&lang=js"
export * from "./yixiangbiao.vue?vue&type=script&lang=js"
import style0 from "./yixiangbiao.vue?vue&type=style&index=0&id=5f3cfdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3cfdf4",
  null
  
)

export default component.exports